(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mens-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var start = function (root) {
      root.querySelectorAll('[data-mens-testimonials]').forEach(function (section) {
        if (section.dataset.mtKlaar === '1') return;
        section.dataset.mtKlaar = '1';
        var viewport = section.querySelector('[data-mt-viewport]');
        var track = section.querySelector('[data-mt-track]');
        var dots = section.querySelector('[data-mt-dots]');
        if (!viewport || !track || !dots) return;

        var echte = Array.prototype.slice.call(track.querySelectorAll('[data-mt-card]'));
        var n = echte.length;
        if (n === 0) return;

        var klonen = 0;      // aantal kopieën vóór en na de echte kaarten (= kaarten per beeld)
        var stap = 0;        // kaartbreedte + tussenruimte
        var index = 0;       // 0..n-1, welke echte kaart links staat
        var actief = false;  // carrousel actief (meer kaarten dan er in beeld passen)
        var bezig = false;   // animatie loopt
        var sleep = null;    // sleepstatus

        var perBeeld = function () {
          var s = kaartStap();
          if (!s) return 1;
          return Math.max(1, Math.round((viewport.clientWidth + gap()) / s));
        };
        var gap = function () {
          var g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
          return isNaN(g) ? 0 : g;
        };
        var kaartStap = function () {
          var eerste = track.querySelector('[data-mt-card]');
          return eerste ? eerste.getBoundingClientRect().width + gap() : 0;
        };
        var zetPositie = function (animatie) {
          track.classList.toggle('is-animating', !!animatie);
          var x = Math.round(-(index + klonen) * stap * 100) / 100;
          track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
        };
        var werkDotsBij = function () {
          var k = ((index % n) + n) % n;
          dots.querySelectorAll('.mens-testimonials__dot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === k);
            d.setAttribute('aria-current', i === k ? 'true' : 'false');
          });
        };
        var normaliseer = function () {
          // Na een animatie naar een kopie: stil terugspringen naar de echte kaart.
          if (index < 0 || index >= n) {
            index = ((index % n) + n) % n;
            zetPositie(false);
          }
        };
        var gaNaar = function (nieuw, animatie) {
          if (!actief) return;
          index = nieuw;
          bezig = !!animatie;
          zetPositie(animatie);
          werkDotsBij();
          if (!animatie) { bezig = false; normaliseer(); }
        };
        track.addEventListener('transitionend', function (e) {
          if (e.target !== track) return;
          bezig = false;
          normaliseer();
        });
        // Vangnet als transitionend uitblijft (tab op de achtergrond, reduced motion)
        var vangnet = null;
        var planVangnet = function () {
          if (vangnet !== null) window.clearTimeout(vangnet);
          vangnet = window.setTimeout(function () { vangnet = null; if (bezig) { bezig = false; normaliseer(); } }, 700);
        };

        var bouw = function () {
          // kopieën weghalen en opnieuw plaatsen op basis van de huidige breedte
          track.querySelectorAll('[data-mt-kloon]').forEach(function (k) { k.remove(); });
          echte.forEach(function (k) { track.appendChild(k); });
          track.classList.remove('is-animating');
          track.style.transform = '';
          var pb = perBeeld();
          actief = n > pb;
          dots.innerHTML = '';
          dots.hidden = !actief;
          klonen = 0;
          if (!actief) { index = 0; return; }
          klonen = pb;
          var maak = function (bron) {
            var k = bron.cloneNode(true);
            k.setAttribute('data-mt-kloon', '1');
            k.removeAttribute('data-mt-card');
            k.setAttribute('aria-hidden', 'true');
            k.removeAttribute('data-shopify-editor-block');
            return k;
          };
          for (var i = n - klonen; i < n; i++) track.insertBefore(maak(echte[((i % n) + n) % n]), track.firstChild);
          for (var j = 0; j < klonen; j++) track.appendChild(maak(echte[j % n]));
          for (var d = 0; d < n; d++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'mens-testimonials__dot';
            b.setAttribute('aria-label', 'Show review ' + (d + 1) + ' of ' + n);
            b.dataset.index = d;
            b.addEventListener('click', function (e) {
              var doel = Number(e.currentTarget.dataset.index);
              var huidig = ((index % n) + n) % n;
              if (doel === huidig) return;
              // kortste weg, ook over de rand heen
              var delta = doel - huidig;
              if (delta > n / 2) delta -= n;
              if (delta < -n / 2) delta += n;
              gaNaar(index + delta, true);
              planVangnet();
            });
            dots.appendChild(b);
          }
          stap = kaartStap();
          index = ((index % n) + n) % n;
          zetPositie(false);
          werkDotsBij();
        };

        // Slepen met muis of vinger
        viewport.addEventListener('pointerdown', function (e) {
          if (!actief || bezig || (e.pointerType === 'mouse' && e.button !== 0)) return;
          sleep = { id: e.pointerId, x: e.clientX, y: e.clientY, dx: 0, richting: null };
          track.classList.remove('is-animating');
          viewport.classList.add('is-dragging');
          try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
        });
        viewport.addEventListener('pointermove', function (e) {
          if (!sleep || e.pointerId !== sleep.id) return;
          var dx = e.clientX - sleep.x;
          var dy = e.clientY - sleep.y;
          if (sleep.richting === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) sleep.richting = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (sleep.richting !== 'x') return;
          sleep.dx = dx;
          e.preventDefault();
          track.style.transform = 'translate3d(' + (-(index + klonen) * stap + dx) + 'px, 0, 0)';
        });
        var eindeSleep = function (e) {
          if (!sleep || e.pointerId !== sleep.id) return;
          var dx = sleep.dx;
          sleep = null;
          viewport.classList.remove('is-dragging');
          try { viewport.releasePointerCapture(e.pointerId); } catch (err) {}
          var drempel = Math.min(40, stap * 0.15);
          var stappen = 0;
          if (Math.abs(dx) > drempel) stappen = Math.max(1, Math.round(Math.abs(dx) / stap)) * (dx < 0 ? 1 : -1);
          gaNaar(index + stappen, true);
          planVangnet();
        };
        viewport.addEventListener('pointerup', eindeSleep);
        viewport.addEventListener('pointercancel', eindeSleep);
        viewport.addEventListener('lostpointercapture', function (e) { if (sleep && e.pointerId === sleep.id) eindeSleep(e); });
        viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

        // Pijltjestoetsen als het venster focus heeft
        viewport.setAttribute('tabindex', '0');
        viewport.addEventListener('keydown', function (e) {
          if (!actief || bezig) return;
          if (e.key === 'ArrowRight') { gaNaar(index + 1, true); planVangnet(); e.preventDefault(); }
          if (e.key === 'ArrowLeft') { gaNaar(index - 1, true); planVangnet(); e.preventDefault(); }
        });

        // Opnieuw opbouwen bij breedteverandering (eerste layout, fonts, draaien van het toestel)
        var herbouwTimer = null;
        var laatsteBreedte = 0;
        var herbouw = function () {
          if (herbouwTimer !== null) window.clearTimeout(herbouwTimer);
          herbouwTimer = window.setTimeout(function () {
            herbouwTimer = null;
            var b = viewport.clientWidth;
            if (b === laatsteBreedte && stap === kaartStap()) return;
            laatsteBreedte = b;
            bouw();
          }, 80);
        };
        window.addEventListener('resize', herbouw);
        window.addEventListener('load', herbouw);
        if (window.ResizeObserver) new ResizeObserver(herbouw).observe(viewport);
        bouw();
        laatsteBreedte = viewport.clientWidth;
      });
    };
    start(document);
    document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
